// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-contact----Contact-module---container---JOx2R","locationContainer":"src-components-contact----Contact-module---locationContainer---2RkcX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/contact/Contact.module.css
// module id = 178
// module chunks = 35783957827783 36829835628245 276599015875551